/** Angular */
import { BydRuntimeService } from '../services/byd-runtime.service';

/**
 * The Beyond environment function that will be executed when the application is initialized.
 *
 * @param bydEnvRuntimeService the beyond runtime service
 * @returns Observable
 */
export function bydAppInitializerFn<U>(bydEnvRuntimeService: BydRuntimeService<U>) {
  return () => bydEnvRuntimeService.loadBydEnvironment().subscribe();
}
